import { memo } from 'react'
import { View } from 'react-native'

import CircleButton from '@nxt-insurance/ui-kit/components/CircleButton'

import { Icon } from '@/components/Icon'
import { BUTTONS_IDS, EVENTS } from '@/constants/analytics'

import type { Carousel } from './schema'
import { carouselStyles } from './styles'

interface CustomButtonGroup {
  next: () => void
  previous: () => void
  arrowsHorizontalAlignment: Carousel['arrowsHorizontalAlignment']
  track: (event: string, data: Record<string, unknown>) => void
}

export const CustomButtons = memo(
  ({ next, previous, arrowsHorizontalAlignment, track }: CustomButtonGroup) => {
    const { buttonGroup } = carouselStyles({
      alignArrows: arrowsHorizontalAlignment ?? 'center',
    })

    return (
      <View className={buttonGroup()}>
        <CircleButton
          icon={<Icon icon={{ name: 'action.chevronLeft_24' }} size="small" />}
          onPress={() => {
            if (previous) {
              track(EVENTS.ButtonClicked, {
                buttonId: BUTTONS_IDS.STORIES_BUTTON_PREVIOUS,
              })
              previous()
            }
          }}
        />
        <CircleButton
          icon={<Icon icon={{ name: 'action.chevronRight_24' }} size="small" />}
          onPress={() => {
            if (next) {
              track(EVENTS.ButtonClicked, {
                buttonId: BUTTONS_IDS.STORIES_BUTTON_NEXT,
              })
              next()
            }
          }}
        />
      </View>
    )
  }
)
